import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TicketCreatePage } from '@/features/admin/tickets/tickets-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau ticket (porting README #91). */
export const Route = createFileRoute('/$tenant/support/new')({ component: NewTicketRoute });

function NewTicketRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="tickets"
      crumbs={[{ label: t('nav.items.tickets') }, { label: t('admin.tickets.newTitle') }]}
    >
      <TicketCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
